<template>
  <div class="counter">
    <div class="value">
      {{ value }}
    </div>
    <div class="label">
      <template v-if="options['General']">
        {{ options['General']['Counter Label'].value }}
      </template>
    </div>
  </div>
</template>

<script>
  import { VIZ_CONFIGS } from './../constants/VisualizationConfigs'
  export default {
    props: {
      data: {
        required: true,
        type: Object,
        default: () => { return { rows: [], columns: [] } },
      },
      options: {
        required: false,
        type: Object,
        default: () => { return VIZ_CONFIGS.counter },
      },
    },
    computed: {
      value () {
        if (this.data.rows.length <= 0) { return '' }
        let dataValue
        let rowNumber = this.options['General']['Counter Value Row Number'].value - 1
        let colName = this.options['General']['Counter Value Column Name'].value
        if (this.options['General']['Count Rows'].value) { dataValue = this.data.rows.length } else if (colName) { dataValue = this.data.rows[rowNumber][colName] } else { dataValue = this.data.rows[0][0] }

        if (typeof dataValue !== 'number') { return '0.00' }
        let place = this.options['Format']['Formatting Decimal Place'].value
        let prefix = this.options['Format']['Formatting String Prefix'].value
        let suffix = this.options['Format']['Formatting String Suffix'].value
        let int = Math.floor(dataValue)
        let decimal = ((dataValue - int).toFixed(place > 100 ? 100 : place) + '').split('.')[1]
        int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + this.options['Format']['Formatting Thousands Separator'].value)
        let val = int + (place > 0 ? (this.options['Format']['Formatting Decimal Character'].value + decimal) : '')
        return prefix + val + suffix
      },
    },
    watch: {
    },
    mounted () {
    },
  }
</script>

<style scoped>
.counter{
    text-align: center;
    padding: 10px 15px;
        height: fit-content !important;
    width: fit-content !important;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    right: 0;
}
.counter > .value{
    font-size:35px;
    font-weight:300;
}
.counter > .label{
font-size: 25px;
    font-weight: 300;
    color: lightgray;
    margin-top: 10px;
}
</style>
